import KitchenSubOrder from '../models/orders/kitchenSubOrder';
import {
  SubOrderStatusUpdate,
  OrderItemStatusUpdate,
} from '../models/orders/orderItemUpdateStatus';

const mapKitchenSubOrderToSubOrderStatusUpdate = (
  kitchenSubOrder: KitchenSubOrder
): SubOrderStatusUpdate => {
  const orderItemStatuses: OrderItemStatusUpdate[] =
    kitchenSubOrder.orderItems.map((orderItem) => ({
      orderItemId: orderItem.id,
      isCompleted: orderItem.isCompleted,
    }));

  return {
    subOrderId: kitchenSubOrder.id,
    orderStatus: kitchenSubOrder.orderStatus,
    orderItemStatuses,
  };
};

export default mapKitchenSubOrderToSubOrderStatusUpdate;
